query GetEmployees {
  employees {
    id
    name
    email
    worksAtFp
    salesforceLicenceActive
    roles {
      id
      name
    }
  }
}
